import React, { useEffect, useState } from 'react';
import { Button, Form, Card, Alert, Badge, Row, Col } from 'react-bootstrap';
import { getAdminSettings, updateAdminSettings } from '../../api/context/adminSettings/index';
import Loader from '../../components/loader/loader';
import toast from 'react-hot-toast';
import { checkUserPermissions } from '../../helpers/permission';
import ErrorState from '../../components/Error/errorState';

const AdminSettings = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [settings, setSettings] = useState(null);
    const [isSaving, setIsSaving] = useState(false);

    // Logistic partner options with colors
    const logisticPartners = [
        {
            value: 'pidge',
            label: 'Pidge',
            color: '#6f42c1', // Purple
            bgColor: 'rgba(111, 66, 193, 0.1)'
        },
        {
            value: 'volta',
            label: 'Volta',
            color: '#0d6efd', // Blue
            bgColor: 'rgba(13, 110, 253, 0.1)'
        }
    ];

    // Yes/No options for dropdowns
    const yesNoOptions = [
        { value: true, label: 'Yes' },
        { value: false, label: 'No' }
    ];

    useEffect(() => {
        fetchAdminSettings();
    }, []);

    const fetchAdminSettings = () => {
        setLoading(true);
        setError(null);
        getAdminSettings()((response) => {
            if (response?.statusCode === 200) {
                setSettings(response.data);
            } else {
                setError(response?.message || 'Failed to fetch settings');
                // toast.error(response?.message || 'Failed to fetch settings');
            }
            setLoading(false);
        });
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setSettings(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : type === 'number' ? parseFloat(value) : value === 'true'
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSaving(true);

        updateAdminSettings(settings)((response) => {
            if (response?.statusCode === 200) {
                toast.success('Settings updated successfully');
                fetchAdminSettings();
            } else {
                toast.error(response?.message || 'Failed to update settings');
            }
            setIsSaving(false);
        });
    };

    return (
        <div className="admin-settings-container">
            <div className="row">
                <div className="col-12">
                    <div className="d-flex justify-content-between align-items-stretch mb-4">
                        <div className="d-flex align-items-center">
                            <h3 className="mb-0 fw-bolder" style={{ fontSize: '1.8rem' }}>Admin Settings</h3>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    
                        <div className="p-4 border-1 border-danger">
                         

                            {loading ? (
                                <div className="text-center py-4">
                                    <Loader />
                                </div>
                            ) : settings === null ? (
                                <ErrorState onRetry={fetchAdminSettings} />
                            ) : (
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        {/* <Col lg={4} md={6} className="mb-4">
                                            <Form.Group controlId="logisticsProvider">
                                                <Form.Label className="fw-bold">Logistic Partner</Form.Label>
                                                <Form.Select
                                                    name="logisticsProvider"
                                                    value={settings.logisticsProvider || ''}
                                                    onChange={handleInputChange}
                                                    className="border-2"
                                                >
                                                    {logisticPartners.map(partner => (
                                                        <option key={partner.value} value={partner.value}>
                                                            {partner.label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col> */}

                                        <Col lg={4} md={6} className="mb-4">
                                            <Form.Group controlId="locationRadius">
                                                <Form.Label className="fw-bold">Allowed Location Radius (km)</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    name="locationRadius"
                                                    value={settings.locationRadius || 0}
                                                    onChange={handleInputChange}
                                                    className="border-2"
                                                    min="0"
                                                    step="1"
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col lg={4} md={6} className="mb-4">
                                            <Form.Group controlId="handlingCharge">
                                                <Form.Label className="fw-bold">Handling Charge ($)</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    name="handlingCharge"
                                                    value={settings.handlingCharge || 0}
                                                    onChange={handleInputChange}
                                                    className="border-2"
                                                    min="0"
                                                    step="0.01"
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col lg={4} md={6} className="mb-4">
                                            <Form.Group controlId="limitForVtoUse">
                                                <Form.Label className="fw-bold">Virtual Try On Limit</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    name="limitForVtoUse"
                                                    value={settings.limitForVtoUse || 0}
                                                    onChange={handleInputChange}
                                                    className="border-2"
                                                    min="0"
                                                    step="1"
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col lg={4} md={6} className="mb-4">
                                            <Form.Group controlId="numberOfDatesForNew">
                                                <Form.Label className="fw-bold">New Arrivals Tag Show (days)</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    name="numberOfDatesForNew"
                                                    value={settings.numberOfDatesForNew || 0}
                                                    onChange={handleInputChange}
                                                    className="border-2"
                                                    min="0"
                                                    step="1"
                                                />
                                            </Form.Group>
                                        </Col>

                                        {/* Free Delivery Dropdown */}
                                        <Col lg={4} md={6} className="mb-4">
                                            <Form.Group controlId="isDeliveryFree">
                                                <Form.Label className="fw-bold">Free Delivery</Form.Label>
                                                <Form.Select
                                                    name="isDeliveryFree"
                                                    value={settings.isDeliveryFree}
                                                    onChange={handleInputChange}
                                                    className="border-2"
                                                     style={{ height: '40px' }} 
                                                  
                                                >
                                                    {yesNoOptions.map(option => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                
                                            </Form.Group>
                                        </Col>

                                        {/* Virtual Try On Dropdown */}
                                        <Col lg={4} md={6} className="mb-4">
                                            <Form.Group controlId="showVtoInApp">
                                                        <Form.Label className="fw-bold">Virtual Try On (Enable in App)</Form.Label>
                                                        <Form.Select
                                                            name="showVtoInApp"
                                                            value={settings.showVtoInApp}
                                                            onChange={handleInputChange}
                                                            className="border-2"
                                                             style={{ height: '40px' }} 
                                                        >
                                                            {yesNoOptions.map(option => (
                                                                <option key={option.value} value={option.value}>
                                                                    {option.label}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                
                                                    </Form.Group>
                                        </Col>
                                    </Row>

                                    <div className="d-flex justify-content-end gap-3 mt-4">
                                        <Button
                                            variant="primary"
                                            type="submit"
                                            disabled={isSaving}
                                            className='request_btn'
                                            
                                        >
                                            {isSaving ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    updating settings...
                                                </>
                                            ) : 'Update admin settings'}
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </div>
                   
                </div>
            </div>
        </div>
    );
};

export default AdminSettings;